import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { StateMfa, StatusMfa } from '../types';

const initialState: StateMfa = {
  mfa: { isEnabledForTenant: false, isEnabledForAccount: false, isActiveForAccount: false, canBeDisabled: false, canBeEnabled: false, canBeReset: false },
};

const mfaSlice = createSlice({
  name: 'mfa',
  initialState,
  reducers: {
    setMfaAction(state, action: PayloadAction<StatusMfa>) {
      state.mfa = action.payload;
    },
  },
});

export const { setMfaAction } = mfaSlice.actions;

export const selectorMfa = (state: RootState): StateMfa => state.mfa;

export default mfaSlice.reducer;
